export const ArrowIcon = (color?: string) => (
    <svg width="15" height="15" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.2132 1.0711C23.2132 0.518813 22.7655 0.0710974 22.2132 0.0710974L13.2132 0.0710974C12.6609 0.0710974 12.2132 0.518813 12.2132 1.0711C12.2132 1.62338 12.6609 2.0711 13.2132 2.0711H21.2132V10.0711C21.2132 10.6234 21.6609 11.0711 22.2132 11.0711C22.7655 11.0711 23.2132 10.6234 23.2132 10.0711L23.2132 1.0711ZM1.70711 22.9914L22.9203 1.7782L21.5061 0.363991L0.292893 21.5772L1.70711 22.9914Z"
            fill={color || "#00AAC3"}/>
    </svg>
)